import React from 'react';
import PropTypes from 'prop-types';

import BaseComponent from 'common/BaseComponent';
import {getMessage as msg} from 'MessageBundle';
import theme from './InfoPanel.scss';

export default class InfoPanel extends BaseComponent {

    render() {
        return (
            <div className={theme.InfoPanel}>
                <p className={theme.SearchCount}>{msg('searchComplaint.tooManyResult.searchCount')} {this.props.searchCount}</p>

                <p>{msg('searchComplaint.tooManyResult.searchCancel')}</p>
                <p>{msg('searchComplaint.tooManyResult.exportResults')}</p>
                <p>{msg('searchComplaint.tooManyResult.searchContinue')}</p>
            </div>
        );
    }
}

InfoPanel.propTypes = {
    /**
     * Amount of search result.
     */
    searchCount: PropTypes.number.isRequired
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/Search/InfoPanel/index.js